import connectPlaybackApiSubscriptions from './Playback/connectPlaybackApiSubscriptions';
import connectResumePointsApiSubscriptions from
    './ResumePoints/connectResumePointsApiSubscriptions';
import connectConcurrencyApiSubscriptions from './Concurrency/connectConcurrencyApiSubscriptions';
import connectUserActionsApiSubscriptions from './UserActions/connectUserActionsApiSubscriptions';
import connectUserActionsWatchedSubscriptions from './UserActionsWatched/connectUserActionsWatchedSubscriptions';

const connectApiSubscriptions = middleware => [
    ...connectPlaybackApiSubscriptions(middleware),
    ...connectResumePointsApiSubscriptions(middleware),
    ...connectConcurrencyApiSubscriptions(middleware),
    ...connectUserActionsApiSubscriptions(middleware),
    ...connectUserActionsWatchedSubscriptions(middleware),
];

export default connectApiSubscriptions;
